import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-user',
  templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
